
export default {
    methods: {
        startQuiz: function (level) {
            this.$store.commit('setCurrentStack', this.stack);
            this.$router.push({name: 'stack-quiz', params: {pk: this.stack.id, level: level}});
        },
        returnToCardset() {
            this.$router.push({name: 'cardset-detail', params: {pk: this.$store.getters.currentCardset.id}})
        },
        gotoCardList() {
            this.$router.push({name: 'stack-card-list', params: {pk: this.stack.id}});
        },
        editStack() {
            this.dialog = true;
        },
    },
}